<template>
    <div class="accountBindCode">
        <TopBar></TopBar>
        <WrapManage title="账号—商家编码绑定管理">
            <WrapContent smallImg :img="img" title="尊敬的商家，若您已与孩子王完成合作，并拥有W商家编码，则无须走线上入驻申请，直接进行W编码绑定即可！">
                <ToBind></ToBind>
            </WrapContent>
        </WrapManage>
        <FootBar></FootBar>
    </div>
</template>
<script>
import WrapManage from '@components/wrapManage'
import FootBar from '@components/footBar'
import TopBar from '@components/topBar'
const { WrapContent,ToBind } = WrapManage; 
import img from '@assets/images/success.svg'
export default {
    components:{WrapManage,TopBar,WrapContent,ToBind,FootBar},
    data(){
        return {
            img
        }
    },
    
    beforeCreate(){
        this.$store.dispatch('getUserInfo')
        
    }
  
}
</script>
<style lang="scss" scoped>
.accountBindCode {
    min-height: 100vh;
    @include Flex;
    flex-direction: column;
    justify-content: space-between;
}

</style>







